import { useEffect } from 'react'
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux'
import { AppDispatch, RootState } from '../store'

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const useOutsideClick = (
  refs: {
    element: React.RefObject<any>
    trigger: React.RefObject<any>
  },
  handler: Function
) => {
  useEffect(() => {
    const handleClickOutside = (e: any) => {
      if (
        refs.element.current &&
        !refs.element.current.contains(e.target) &&
        refs.trigger.current?.id !== e.target.id
      ) {
        handler()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => document.removeEventListener('mousedown', handleClickOutside)
    // eslint-disable-next-line
  }, [refs])
}
